import './PostOptimization.scss';
import { useEffect, useState } from 'react';
import { FullPageSpinner } from '@Components/Spinner/Spinner';
import { StreamingOptimizationsLambdaFetch, awaitJSON } from '../../../utils/fetch-utils';
import { PostOptimizationResponse } from './post-optimization-constants';
import { PostOptimizationView } from './PostOptimizationView';

interface PostOptimizationProps {
  company: string;
  runId: string;
  streamingType: string;
}

export const PostOptimization = ({ company, runId, streamingType }: PostOptimizationProps) => {
  const [data, setData] = useState<PostOptimizationResponse>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!company || !runId) return undefined;
    let cancelled = false;
    setData(undefined);
    setError(undefined);

    (async () => {
      try {
        const result = await awaitJSON<PostOptimizationResponse[]>(
          await StreamingOptimizationsLambdaFetch('/optimizations', {
            params: { company, runId, streamingType, type: 'post_optimization' }
          })
        );
        if (cancelled) return;
        if (!result?.[0]) {
          setError('No post-optimization data is available for this run.');
          return;
        }
        setData(result[0]);
      } catch (requestError) {
        if (!cancelled) {
          setError(
            requestError instanceof Error
              ? requestError.message
              : 'Failed to load post-optimization data'
          );
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [company, runId, streamingType]);

  if (error) {
    return <div className='post-optimization-error'>Failed to load: {error}</div>;
  }
  if (!data) return <FullPageSpinner />;

  return (
    <PostOptimizationView
      apiData={data}
      company={company}
      runId={runId}
      streamingType={streamingType}
    />
  );
};
